import Avatar from "@mui/material/Avatar";
import Chip from "@mui/material/Chip";
import { styled } from "@mui/material/styles";

const WarningChip = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#2d2d00" : "#fffde7",
  color: "#E6A700",
  fontWeight: "bold",
  border: "1px solid #FFC700",
  "& .MuiChip-label": {
    color: "#E6A700",
  },
}));

export function renderAlarm(value, t) {
  if (value === 0) {
    return (
      <Chip
        label={"0"}
        variant="outlined"
        size="small"
        sx={{ minWidth: "40px", opacity: 0.6 }}
      />
    );
  }
  return <Chip label={value} color="error" sx={{ minWidth: "40px" }} />;
}

export function renderWarning(value, t) {
  if (value === 0) {
    return (
      <Chip
        label={"0"}
        variant="outlined"
        size="small"
        sx={{ minWidth: "40px", opacity: 0.6 }}
      />
    );
  }
  return <WarningChip label={value} sx={{ minWidth: "40px" }} />;
}

export function renderOnline(value, t) {
  return <Chip label={t("dashboard.statusChip.online")} color="success" />;
}

// Success chip that shows a provided value as label (used for normal state)
export function renderSuccess(value, t) {
  return <Chip label={value} color="success" sx={{ minWidth: "40px" }} />;
}

export function renderOffline(value, t) {
  return <Chip label={t("dashboard.statusChip.offline")} color="error" />;
}

export function renderAlarmm(value, t) {
  return <Chip label={t("dashboard.statusChip.alarm")} color="error" />;
}

export function renderWarningg(value, t) {
  return <WarningChip label={t("dashboard.statusChip.warning")} />;
}

export function renderNormal(value, t) {
  return <Chip label={t("dashboard.statusChip.normal")} color="success" />;
}

export function renderAvatar(params) {
  if (params.value == null) {
    return "";
  }

  return (
    <Avatar
      sx={{
        backgroundColor: params.value.color,
        width: "24px",
        height: "24px",
        fontSize: "0.85rem",
      }}
    >
      {params.value.name.toUpperCase().substring(0, 1)}
    </Avatar>
  );
}
